<template>
    <table-for-request :id-request="Number(requestId)" type-request="Massive"/>
</template>
<script>
import tableForRequest from '../../components/tableForProcessRequest'
export default {
    name: 'RequestMassiveToProcess',
    title: 'Solicitudes Masivas por Procesar | Infoguia',
    props: {
            requestId: {
                required: true,
            },
        },
        components: {
            tableForRequest,
        },
}
</script>